"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoursesSearcherApi = void 0;
const Search_utils_1 = require("../Search.utils");
const SearchBaseApi_1 = require("../SearchBaseApi");
class CoursesSearcherApi extends SearchBaseApi_1.SearchBaseApi {
    constructor() {
        super(...arguments);
        this.hitsDefaultValue = 300;
    }
    buildQuery(params) {
        const builder = new Search_utils_1.SearchParamsBuilder();
        builder.Append('q', params.query || '*');
        builder.Append('lang', params.language ? params.language.toLowerCase() : params.language);
        builder.Append('hits', params.hits ? params.hits : this.hitsDefaultValue);
        return decodeURIComponent(builder.toString());
    }
}
exports.CoursesSearcherApi = CoursesSearcherApi;
